import React from 'react';

import Layout from '../components/layout_selenium_alternative';
import HeroPageIntro from '../sections/HeroPageIntro';
import LayoutPageWrapper from '../components/LayoutPageWrapper';
import Heading from '../components/Heading';

const IndexPage = () => (
  <Layout>
    <HeroPageIntro title="Selenium Alternative" />
    <LayoutPageWrapper horizontalPadding="Small">

    <Heading type="h2" size="Small">1. Easier to use</Heading>

    <p>Endtest is more powerful and easier to use than Selenium.</p>

    <p>We empower users to execute web tests on all major browsers, without the hassle of writing code.</p>

    <p>That means anyone in your team can create stable and reliable tests.</p>

    <p>We even provide a cross-browser cloud, tightly integrated in our platform.</p>

    <Heading type="h2" size="Small">2. Faster results</Heading>
    <p>In order to use Selenium, you have to stitch together an internal framework.</p>

    <p>That can take more than 4-5 months and it becomes difficult to maintain.</p>

    <p>With Endtest, you can start creating and executing your tests from day one.</p>

    <p>That means your company gets a great ROI when using Endtest.</p>


    <Heading type="h2" size="Small">3. Seamless collaboration</Heading>

    <p>It's difficult to collaborate with other colleagues when writing Selenium tests.</p>

    <p>Writing and maintaining code takes a lot of time.</p>

    <p>And you need to store that code in an external Git or SVN system.</p>

    <p>With Endtest, your tests are stored directly in our cloud.</p>

    <p>And each test can be modified directly in the UI, without having to write any code.</p>

    <p>That makes collaboration smooth.</p>


    <Heading type="h2" size="Small">4. End to end capabilities</Heading>

    <p>Create and execute complex end to end tests.</p>

    <p>With Endtest, you can test almost anything, including APIs, emails, SMS messages, PDF files.</p>

    <p>You can even perform screenshot comparisons and SQL queries.</p>

    <p>And orchestration becomes a breeze, with our powerful Endtest API.</p>


    <Heading type="h2" size="Small">5. Reliability</Heading>

    <p>Endtest is more reliable.</p>

    <p>Issues in open-source solutions can take months or even years to get fixed.</p>

    <p>On our side, we always make sure everything works as expected.</p>

    <p>And that means you can focus on your tests, instead of opening issues in GitHub or asking questions on StackOverflow.</p>


    </LayoutPageWrapper>
  </Layout>
);

export default IndexPage;
